export abstract class AbstractCockpitError extends Error {
  protected constructor(
    message: string,
    public readonly code?: string,
    public readonly userMessage: string = message,
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = new.target.name;
  }
}
